import * as React from "react";
import { forwardRef, memo } from "react";
const SvgDotStep = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 8, viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 4, fill: "#9E9FAC" }));
const ForwardRef = forwardRef(SvgDotStep);
const Memo = memo(ForwardRef);
export default Memo;
